import { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const isUserAuthenticated = () => {
  const accessTokenGoogle = localStorage.getItem('accessTokenGoogle');
  const departmentAccessToken = localStorage.getItem('departmentAccessToken');
  const clientAccessTokenGoogle = localStorage.getItem('clientAccessTokenGoogle');

  return !!(accessTokenGoogle || departmentAccessToken || clientAccessTokenGoogle);
};


function Feedback() {
  const isAuthenticated = isUserAuthenticated();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    feedback: ''
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // First Name / Last Name: only letters and spaces
    if (name === 'firstName' || name === 'lastName') {
      if (/[^a-zA-Z\s]/.test(value)) return;
    }

    // Phone: only digits, max 10
    if (name === 'phoneNumber') {
      if (/[^0-9]/.test(value) || value.length > 10) return;
    }

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required.';
    else if (formData.firstName.trim().length < 2) newErrors.firstName = 'First name must be at least 2 characters.';

    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required.';
    else if (formData.lastName.trim().length < 2) newErrors.lastName = 'Last name must be at least 2 characters.';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) newErrors.email = 'Email is required.';
    else if (!emailRegex.test(formData.email)) newErrors.email = 'Enter a valid email address.';

    if (!formData.phoneNumber.trim()) newErrors.phoneNumber = 'Phone number is required.';
    else if (formData.phoneNumber.length !== 10) newErrors.phoneNumber = 'Phone number must be exactly 10 digits.';

    if (!formData.feedback.trim()) newErrors.feedback = 'Feedback is required.';
    else if (formData.feedback.trim().length < 3) newErrors.feedback = 'Feedback must be at least 3 characters.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      await axios.post('https://juridentfeedbackmailbackend-4qnu.onrender.com/send-feedback', {
        name: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        feedback: formData.feedback,
      });

      await axios.post('https://juridentfeedbackmailbackend-4qnu.onrender.com/send-thank-you', {
        email: formData.email,
        name: formData.firstName,
        lastName: formData.lastName,
      });

      toast.success('Feedback sent successfully!');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        feedback: ''
      });
    } catch (error) {
      console.error(error);
      toast.error('Failed to send feedback. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-white flex flex-col">
    {isAuthenticated && <Navbar />}
      <div className="background-circle circle-1"></div>
      <div className="background-circle circle-2"></div>

      <div className="container mx-auto px-6 py-8 max-w-xl">
        <div className="feedback-card bg-[#1a1a2e] rounded-xl p-8">
          <h2 className="text-xl font-semibold text-[#CDA454] text-center mb-8">
            Feedback Form
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* First Name */}
            <div>
              <label className="block text-sm text-gray-400 mb-1">First Name</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </span>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={`w-full bg-[#0a051e] border ${errors.firstName ? 'border-red-500' : 'border-gray-700'} rounded-lg py-2 pl-10 pr-4 focus:outline-none focus:border-[#CDA454]`}
                />
              </div>
              {errors.firstName && <p className="text-red-400 text-xs mt-1">{errors.firstName}</p>}
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-sm text-gray-400 mb-1">Last Name</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </span>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={`w-full bg-[#0a051e] border ${errors.lastName ? 'border-red-500' : 'border-gray-700'} rounded-lg py-2 pl-10 pr-4 focus:outline-none focus:border-[#CDA454]`}
                />
              </div>
              {errors.lastName && <p className="text-red-400 text-xs mt-1">{errors.lastName}</p>}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm text-gray-400 mb-1">Email</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`w-full bg-[#0a051e] border ${errors.email ? 'border-red-500' : 'border-gray-700'} rounded-lg py-2 pl-10 pr-4 focus:outline-none focus:border-[#CDA454]`}
                />
              </div>
              {errors.email && <p className="text-red-400 text-xs mt-1">{errors.email}</p>}
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-sm text-gray-400 mb-1">Phone Number</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </span>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className={`w-full bg-[#0a051e] border ${errors.phoneNumber ? 'border-red-500' : 'border-gray-700'} rounded-lg py-2 pl-10 pr-4 focus:outline-none focus:border-[#CDA454]`}
                />
              </div>
              {errors.phoneNumber && <p className="text-red-400 text-xs mt-1">{errors.phoneNumber}</p>}
            </div>

            {/* Feedback */}
            <div>
              <label className="block text-sm text-gray-400 mb-1">Feedback</label>
              <textarea
                name="feedback"
                value={formData.feedback}
                onChange={handleChange}
                rows="4"
                className={`w-full bg-[#0a051e] border ${errors.feedback ? 'border-red-500' : 'border-gray-700'} rounded-lg py-2 px-4 focus:outline-none focus:border-[#CDA454]`}
              />
              {errors.feedback && <p className="text-red-400 text-xs mt-1">{errors.feedback}</p>}
            </div>

            {/* Submit Button with Loader */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full flex justify-center items-center gap-2 bg-[#CDA454] text-white py-2 rounded-lg transition-colors ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-[#c49b2f]'
                }`}
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                  Sending...
                </>
              ) : (
                'Submit'
              )}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Feedback;
